import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { faqAPI } from '../../services/api';

export interface FaqItem {
  id: string;
  section: string;
  question: string;
  answer: string;
}

interface FaqState {
  items: FaqItem[];
  loading: boolean;
  error: string | null;
  pagination: {
    page: number;
    items_per_page: number;
    total: number;
  };
}

const initialState: FaqState = {
  items: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    items_per_page: 10,
    total: 0,
  },
};

// Async thunks
export const fetchFaqs = createAsyncThunk(
  'faqs/fetchFaqs',
   async (params?: { 
    page?: number; 
    items_per_page?: number; 
  }) => {
    const response = await faqAPI.getFAQs(params);
    // Match categories API response structure
    if (response.data && response.data.data && Array.isArray(response.data.data)) {
      return {
        items: response.data.data,
        pagination: response.data.payload || {
          page: 1,
          items_per_page: 10,
          total: 0,
        }
      };
    } else if (Array.isArray(response.data)) {
      return {
        items: response.data,
        pagination: {
          page: 1,
          items_per_page: response.data.length,
          total: response.data.length,
        }
      };
    } else {
      return {
        items: [],
        pagination: {
          page: 1,
          items_per_page: 10,
          total: 0,
        }
      };
    }
  }
);

export const addFaq = createAsyncThunk(
  'faqs/addFaq',
  async (faq: { section: string; question: string; answer: string }) => {
    const response = await faqAPI.addFaq(faq);
    return response.data;
  }
);

export const updateFaq = createAsyncThunk(
  'faqs/updateFaq',
  async (faq: { id: string; section: string; question: string; answer: string }) => {
    const { id, section, question, answer } = faq;
    const response = await faqAPI.updateFaq(id, { section, question, answer });
    return response.data;
  }
);

export const deleteFaq = createAsyncThunk(
  'faqs/deleteFaq',
  async (id: string) => {
    await faqAPI.deleteFaq(id);
    return id;
  }
);

const faqsSlice = createSlice({
  name: 'faqs',
  initialState,
  
   reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch FAQs';
      })
      // .addCase(addFaq.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.items.unshift(action.payload);
      //   state.total += 1;
      // })
      // .addCase(addFaq.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.error.message || 'Failed to add FAQ';
      // })
      // .addCase(updateFaq.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(updateFaq.fulfilled, (state, action) => {
      //   state.loading = false;
      //   const idx = state.items.findIndex(f => f.id === action.payload.id);
      //   if (idx !== -1) state.items[idx] = action.payload;
      // })
      // .addCase(updateFaq.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.error.message || 'Failed to update FAQ';
      // })
      // .addCase(deleteFaq.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(deleteFaq.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.items = state.items.filter(f => f.id !== action.payload);
      //   state.total -= 1;
      // })
      // .addCase(deleteFaq.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.error.message || 'Failed to delete FAQ';
      // });
  }
});

export const {  clearError } = faqsSlice.actions;
export default faqsSlice.reducer;
